import { humanizeStatus, getLoanStatusClass, getKYCStatusClass, getContributionStatusClass, getGroupStatusClass } from '../../utils/helpers';

export function LoanStatusBadge({ status }) {
  return <span className={`badge ${getLoanStatusClass(status)}`}>{humanizeStatus(status)}</span>;
}

export function KYCStatusBadge({ status }) {
  return <span className={`badge ${getKYCStatusClass(status)}`}>{humanizeStatus(status)}</span>;
}

export function ContributionStatusBadge({ status }) {
  return <span className={`badge ${getContributionStatusClass(status)}`}>{humanizeStatus(status)}</span>;
}

export function GroupStatusBadge({ status }) {
  return <span className={`badge ${getGroupStatusClass(status)}`}>{humanizeStatus(status)}</span>;
}
